<template>
    <div class="report-images-page">
        <ReportImagesHeaderContent
            :component-sid="componentSid"
            :report-number="reportNumber"
            :report-type="reportTypeAsNumber"
        />
        <div class="report-images-page__content">
            <ReportImagesMeasurementSection
                :component-sid="componentSid"
                :report-number="reportNumber"
            />
        </div>
    </div>
</template>

<script setup lang="ts">
import { computed, toRefs } from 'vue'
import ReportImagesHeaderContent from '@/pages/generators/report-images/sections/ReportImagesHeaderContent.vue'
import ReportImagesMeasurementSection from '@/pages/generators/report-images/sections/ReportImagesMeasurementSection.vue'

const props = defineProps<{
    componentSid: string
    reportNumber: string
    reportType: string
}>()

const { componentSid, reportNumber, reportType } = toRefs(props)
const reportTypeAsNumber = computed(() => Number(reportType.value))
</script>

<style scoped lang="scss">
.report-images-page {
    display: flex;
    flex-direction: column;

    max-height: calc(100vh - $navbar-height * 2);

    &__content {
        @include spacing-page;
        overflow-y: auto;

        display: flex;
        flex-direction: column;
        gap: $spacing-m;
    }
}
</style>
